export default class SteppedApplicationForm {

    constructor() {
        this.settings = {
            form: document.querySelector('.js-stepped-application-form')
        };

        this.bindUIActions();
    }

    bindUIActions() {
        if(this.settings.form) {
            // Replace the next button text as this isn't customisable by default in Gravity Forms
            const nextButtons = document.querySelectorAll('.gform_next_button');
            
            if (nextButtons) {
                nextButtons.forEach((nextButton) => {
                    nextButton.value = 'Great, thanks!  Next step';
                });
            }

            // Add the dynamic steps to indicate with page user is on
            const pageStepsElement = document.querySelector('.gf_page_steps');
            const stepSpan = document.createElement('span');
            stepSpan.classList.add('page-indicator');

            if (pageStepsElement) {
                pageStepsElement.prepend(stepSpan);
            }

            const activeStepElement = document.querySelector('.gf_step_active .gf_step_number');

            if (activeStepElement) {
                const totalSteps = document.querySelectorAll('.gf_step').length;
                const activeStepNumber = activeStepElement.textContent;

                const pageIndicator = document.querySelector('.page-indicator');
                if (pageIndicator) {
                    pageIndicator.textContent = `Step ${activeStepNumber} of ${totalSteps}`;
                }
            }

            function toggleChecked(event) {
                const label = event.target.nextElementSibling;

                if (label) {
                  label.classList.add('checked');
                } else {
                  label.classList.remove('checked');
                }
            }

            const choices = document.querySelectorAll('.gchoice');

            choices.forEach((choice) => {
                choice.addEventListener('click', toggleChecked);
            });

        }
    }

};

new SteppedApplicationForm();